import { useServerInfo } from '@go-client/context/ServerInfoContext';
import React from 'react';
import { Redirect } from 'react-router-dom';

import { parseLoggedUserToken, getInstancePropIdIfUserCan } from '../lib/auth';
import {
  resolveGroupsPath,
  resolveItinerariesPath,
  resolveLoginPath,
  resolvePropertiesPath,
} from '@go-client/routes';

/**
 * Dummy component that retrieves the user data and redirects to the appropriate page (currently
 * the user's property)
 *
 */
const Home: React.FC = () => {
  const serverInfo = useServerInfo();

  // ensure there's a valid user
  let apiToken;
  try {
    apiToken = parseLoggedUserToken();
  } catch (e) {
    console.error(e);
    return <Redirect to={resolveLoginPath()} />;
  }

  // if (apiToken.role.access.length === 0) {
  //   console.error(`This user is not assigned to any property`);
  //   return <Redirect to={LOGIN_PATH} />;
  // }

  // resolve an instance property if applicable
  const property = getInstancePropIdIfUserCan(serverInfo, apiToken.role);

  if (property) {
    if (apiToken.groupUser) {
      return <Redirect to={resolveGroupsPath(property, 'bookings')} />;
    } else {
      return <Redirect to={resolveItinerariesPath(property)} />;
    }
  } else {
    return <Redirect to={resolvePropertiesPath()} />;
  }
};

export default Home;
